import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';
import { Mail } from 'lucide-react';

export const TestEmailButton = () => {
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    email: 'yannick.martins@outlook.com',
    name: 'Yannick Martins',
    subject: 'Test Email - Configuration Resend',
    message: 'Ceci est un email de test pour vérifier la configuration Resend avec le domaine sakuraima.com'
  });

  const testEmail = async () => {
    if (!formData.email || !formData.email.includes('@')) {
      toast({
        title: "Erreur",
        description: "Veuillez saisir un email valide",
        variant: "destructive"
      });
      return;
    }

    if (!formData.subject || !formData.message) {
      toast({
        title: "Erreur",
        description: "Le sujet et le message sont requis",
        variant: "destructive"
      });
      return;
    }

    setSending(true);
    try {
      console.log('Testing email to:', formData.email);
      
      const { data, error } = await supabase.functions.invoke('send-admin-email', {
        body: {
          recipientEmail: formData.email,
          recipientName: formData.name,
          subject: formData.subject,
          message: formData.message
        }
      });

      console.log('Email response:', { data, error });

      if (error) {
        toast({
          title: "Erreur",
          description: error.message || "Impossible d'envoyer l'email de test",
          variant: "destructive"
        });
      } else {
        toast({
          title: "Email de test envoyé",
          description: `Vérifiez votre boîte email: ${formData.email}`
        });
        setOpen(false);
      }
    } catch (error: any) {
      console.error('Error testing email:', error);
      toast({
        title: "Erreur",
        description: error.message || "Erreur lors de l'envoi",
        variant: "destructive"
      });
    } finally {
      setSending(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm">
          <Mail className="h-4 w-4 mr-2" />
          Tester les emails
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>Tester l'envoi d'email</DialogTitle>
          <DialogDescription>
            Envoyez un email de test pour vérifier la configuration Resend avec le domaine sakuraima.com
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="email">Email destinataire</Label>
            <Input
              id="email"
              type="email"
              placeholder="exemple@email.com"
              value={formData.email}
              onChange={(e) => setFormData(prev => ({ ...prev, email: e.target.value }))}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="name">Nom du destinataire</Label>
            <Input
              id="name"
              placeholder="John Doe"
              value={formData.name}
              onChange={(e) => setFormData(prev => ({ ...prev, name: e.target.value }))}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="subject">Sujet</Label>
            <Input
              id="subject"
              placeholder="Sujet de l'email"
              value={formData.subject}
              onChange={(e) => setFormData(prev => ({ ...prev, subject: e.target.value }))}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="message">Message</Label>
            <Textarea
              id="message"
              placeholder="Contenu du message..."
              rows={4}
              value={formData.message}
              onChange={(e) => setFormData(prev => ({ ...prev, message: e.target.value }))}
            />
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => setOpen(false)}>
            Annuler
          </Button>
          <Button onClick={testEmail} disabled={sending}>
            <Mail className="h-4 w-4 mr-2" />
            {sending ? 'Envoi en cours...' : 'Envoyer le test'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
